import { useState } from "react";
import html2pdf from "html2pdf.js";
import RapportProjet from "./RapportProjet";
import ReportOptionsPanel, { DEFAULT_SECTIONS } from "./ReportOptionsPanel";
const NOMS_CORRIGES = {
  "longrines":           "Longrines",
  "Pieux Beton":         "Pieux Béton",
  "Pieux Fores":         "Pieux Forés",
  "pieux beton":         "Pieux Béton",
  "pieux fores":         "Pieux Forés",
  "Ecran Ancre":         "Écran Ancré",
  "Colonnes Ballastees": "Colonnes Ballastées",
};
const normaliserNom = (nom) => NOMS_CORRIGES[nom] || nom || "";

export default function PageRapport({ diagnosticBackend, donneesProjet, onRetour, onAgent, onSupprDialogueRapport = () => {} }) {
  const [sectionsActives, setSectionsActives] = useState(() => ({
    ...DEFAULT_SECTIONS,
    dialogue_expert: (donneesProjet?.dialogueExpertRapport?.length || 0) > 0,
  }));

  const toggleSection = (key) =>
    setSectionsActives(prev => ({ ...prev, [key]: !prev[key] }));

  const hasAnalyse =
    diagnosticBackend?.adequation?.classement?.length > 0 ||
    donneesProjet?.solutions?.length > 0;

  if (!donneesProjet || !hasAnalyse) {
    return (
      <div style={{
        textAlign:"center", padding:"60px 24px",
        maxWidth:600, margin:"0 auto",
        fontFamily:"'Segoe UI', sans-serif",
      }}>
        <h2 style={{ fontSize:20, fontWeight:700, color:"#374151", marginBottom:16 }}>
          Aucune analyse disponible
        </h2>
        <p style={{ fontSize:14, color:"#6b7280", lineHeight:1.7 }}>
          Veuillez lancer une analyse avant de générer un rapport.
        </p>
        <button
          onClick={onRetour}
          style={{
            marginTop:24, padding:"10px 24px",
            background:"#1d4ed8", color:"#fff",
            border:"none", borderRadius:8,
            fontSize:14, fontWeight:600, cursor:"pointer",
          }}
        >
          Aller à Projet
        </button>
      </div>
    );
  }

  // FIX-RANK.c — source backend quand classement disponible, legacy sinon
  const backendDisponible = Boolean(diagnosticBackend?.adequation?.classement?.length);
  const legacySolutions = donneesProjet?.solutions || [];
  const solutionsPDF =
    backendDisponible
      ? diagnosticBackend.adequation.classement.map(item => {
          const id   = item.id;
          const data = diagnosticBackend.adequation.solutions?.[id] || {};
          const leg  = legacySolutions.find(s => s.id === id) || {};
          return {
            id,
            nom:           normaliserNom(data.nom || leg.nom || id),
            niveau:        item.niveau || data.niveau,
            score:         null,
            icone:         leg.icone || null,
            avantages:      data.motifs_positifs || [],
            inconvenients:  data.avertissements  || [],
            motifs_negatifs: data.motifs_negatifs || [],
            modules_geo5:   diagnosticBackend.modules_geo5
                             ?.par_solution_eligible?.[id]
                             || leg.modules_geo5 || [],
          };
        })
      : legacySolutions;

  const excluesProjet = Object.entries(diagnosticBackend?.eligibilite?.exclues || {})
    .map(([id, data]) => {
      const leg = legacySolutions.find(s => s.id === id) || {};
      return {
        id,
        nom:   normaliserNom(leg.nom || id.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())),
        icone: leg.icone || null,
        regles:          Array.isArray(data?.regles) ? data.regles
                         : typeof data === "string"  ? [data]
                         : Object.keys(data || {}),
        motifs:          data?.motifs          || [],
        regles_resolues: data?.regles_resolues || [],
      };
    });

  const alertesProjet =
    diagnosticBackend?.alertes?.en1997_2 ||
    donneesProjet?.alertes_projet ||
    [];

  const telechargerPDF = () => {
    const element = document.getElementById("rapport-contenu");
    if (!element) return;
    const reference = donneesProjet?.clientInfo?.codeRef || "";
    const options = {
      margin:      [15, 10, 15, 10],
      filename:    `${reference || "rapport-geotechnique"}.pdf`,
      image:       { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        letterRendering: true,
        ignoreElements: (el) => el.classList.contains("no-print"),
      },
      jsPDF:     { unit: "mm", format: "a4", orientation: "portrait", compress: true },
      pagebreak: {
        mode: ["avoid-all", "css", "legacy"],
        before: ".page-break-before",
        avoid: [".alerte-item", ".tableau-comparatif", ".solution-card"],
      },
    };

    const drawFooter = (doc, pageNum, totalPages) => {
      const pageH = doc.internal.pageSize.getHeight();
      const pageW = doc.internal.pageSize.getWidth();
      const footerY = pageH - 8;
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.3);
      doc.line(15, pageH - 12, pageW - 15, pageH - 12);
      doc.setFontSize(8);
      doc.setTextColor(80, 80, 80);
      doc.setFont("helvetica", "bold");
      doc.text("GeoExpert FR — Conseil Géotechnique Assisté par IA", 15, footerY);
      doc.setFont("helvetica", "normal");
      doc.text(`Page ${pageNum} / ${totalPages}`, pageW / 2, footerY, { align: "center" });
      doc.text(reference, pageW - 15, footerY, { align: "right" });
      doc.setFontSize(7);
      doc.setTextColor(130, 130, 130);
      doc.setFont("helvetica", "italic");
      doc.text(
        "Résultats indicatifs — validation G2 PRO requise (NF P94-500)",
        pageW / 2,
        pageH - 4,
        { align: "center" }
      );
    };

    html2pdf()
      .set(options)
      .from(element)
      .toPdf()
      .get("pdf")
      .then((doc) => {
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          drawFooter(doc, i, totalPages);
        }
      })
      .save();
  };

  return (
    <div style={{ maxWidth:960, margin:"0 auto", padding:"24px", fontFamily:"'Segoe UI', sans-serif" }}>
      <div style={{
        display:"flex", alignItems:"center", justifyContent:"space-between",
        marginBottom:20,
      }}>
        <button
          onClick={onRetour}
          style={{
            background:"transparent", border:"1.5px solid #d1d5db",
            borderRadius:8, padding:"8px 18px",
            fontSize:13, fontWeight:600, color:"#374151", cursor:"pointer",
          }}
        >
          ← Retour à l'analyse
        </button>
        <button
          onClick={telechargerPDF}
          style={{
            display:"flex", alignItems:"center", gap:6,
            background:"#1d4ed8", color:"#fff",
            border:"none", borderRadius:8,
            padding:"9px 20px", fontSize:13, fontWeight:700, cursor:"pointer",
          }}
        >
          ⬇ Télécharger PDF
        </button>
      </div>

      <ReportOptionsPanel
        sectionsActives={sectionsActives}
        onToggle={toggleSection}
      />

      {!backendDisponible && (
        <div style={{
          background:"#FFF7ED", border:"1.5px solid #F59E0B", borderRadius:10,
          padding:"12px 20px", marginBottom:16,
          display:"flex", alignItems:"center", gap:10,
          fontSize:13, color:"#92400E", fontWeight:600,
        }}>
          ⚠️ Mode dégradé — données backend indisponibles. Ce rapport est généré depuis l'analyse locale.
        </div>
      )}
      <RapportProjet
        donneesProjet={donneesProjet}
        solutions={solutionsPDF}
        alertesProjet={alertesProjet}
        excluesProjet={excluesProjet}
        onNavigate={onAgent}
        sectionsActives={sectionsActives}
        onSupprDialogueRapport={onSupprDialogueRapport}
        diagnosticBackend={diagnosticBackend}
      />
    </div>
  );
}
